import TimelineIcon from '@material-ui/icons/Timeline';
import {
  ApiBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  FrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { convertLegacyRouteRef } from '@backstage/core-compat-api';
import { rootRouteRef } from './routes';
import { grafanaApiRef, GrafanaApiClient } from './api/grafanaApi';
import { observabilityViewPermission } from './permissions';
import './styles.css';

const grafanaApi = ApiBlueprint.make({
  name: 'grafana',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: grafanaApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
        },
        factory: ({ discoveryApi, fetchApi }) =>
          new GrafanaApiClient({ discoveryApi, fetchApi }),
      }),
    ),
});

const observabilityPage = PageBlueprint.make({
  name: 'observability',
  params: {
    path: '/observability',
    title: 'Observability',
    icon: <TimelineIcon fontSize="inherit" />,
    routeRef: convertLegacyRouteRef(rootRouteRef),
    loader: async () => {
      const { ObservabilityPage } = await import(
        './components/ObservabilityPage/ObservabilityPage'
      );
      const { RequirePermission } = await import(
        '@backstage/plugin-permission-react'
      );
      return (
        <RequirePermission permission={observabilityViewPermission}>
          <ObservabilityPage />
        </RequirePermission>
      );
    },
  },
});

export const grafanaObservabilityFrontendPlugin: FrontendPlugin =
  createFrontendPlugin({
    pluginId: 'grafana-observability-frontend',
    extensions: [grafanaApi, observabilityPage],
    routes: {
      root: convertLegacyRouteRef(rootRouteRef),
    },
  });

// Re-export para uso no App.tsx enquanto ele estiver no compat bridge (S2.1)
export { ObservabilityPage as GrafanaObservabilityFrontendPage } from './components/ObservabilityPage/ObservabilityPage';

export default grafanaObservabilityFrontendPlugin;
